import SystemEmailEditor from '@Components/General/SystemEmailEditor';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';
import {
    emailDraftQueryOptions,
    emailRecipientsContactsQueryOptions,
} from '@utils/queryOptions';

const EditEmailDraftTemplate = () => {
    const { t } = useTranslation();
    const { draftId } = useParams({});

    const { data } = useSuspenseQuery(emailDraftQueryOptions(draftId));

    const { mutate, isPending } = useMutation({
        mutationKey: ['updateEmailDraftForm'],
    });

    const handleSave = data => {
        const formData = { ...data };
        formData.body = formData.html;
        delete formData.html;
        return mutate([draftId, formData]);
    };

    const { data: contact } = useSuspenseQuery(
        emailRecipientsContactsQueryOptions(draftId),
    );

    const contactData = contact?.results?.[0];

    const mergeTags = {
        first_name: contactData?.first_name,
        last_name: contactData?.last_name,
        prefix: contactData?.prefix,
        suffix: contactData?.suffix,
        description: contactData?.description,
        country: contactData?.country,
        state: contactData?.state,
        city: contactData?.city,
        neighborhood: contactData?.neighborhood,
        street: contactData?.street,
        house_number: contactData?.house_number,
        apartment_number: contactData?.apartment_number,
        zip_code: contactData?.zip_code,
        address_notes: contactData?.address_notes,
        phone_numbers: contactData?.phone_numbers,
        email_addresses: contactData?.email_addresses,
        profile_picture: contactData?.profile_picture,
    };

    return (
        <SystemEmailEditor
            initialData={data?.template || undefined}
            onSave={handleSave}
            saving={isPending}
            title={data?.subject || t('Untitled Email')}
            setTitle={subject => handleSave({ subject })}
            selectTamplateOpen={!data?.template}
            mergeTags={mergeTags}
        />
    );
};

export default EditEmailDraftTemplate;
